import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Importing all the themes
import ThemeOne from "../themes/theme-one";
import Portfolio from "../themes/portfolio";
import PortfolioSingle from "../themes/portfolio-single";
import About from "../themes/about";
import BlogA from "../themes/blog-a";
import BlogASingle from "../themes/blog-a-single";
import Blog from "../themes/blog";
import BlogSingle from "../themes/blog-single";
import Contact from "../themes/contact";
import LeadershipSingle from "../themes/leadership-single";

const MyRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ThemeOne />} />
        <Route path="/our-work" element={<Portfolio />} />
        <Route path="/articles" element={<BlogA />} />
        <Route path="/articles/:slug" element={<BlogASingle />} />
        {/* Dynamic route for single work item */}
        <Route path="/work/:slug" element={<PortfolioSingle />} />
        <Route path="/portfolio-single" element={<PortfolioSingle />} />
        <Route path="/about" element={<About />} />
        <Route path="/resources" element={<Blog />} />
        {/* Dynamic route for single blog post */}
        <Route path="/blog/:slug" element={<BlogSingle />} />
        <Route path="/resources/:slug" element={<BlogSingle />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/leadership/:id" element={<LeadershipSingle />} />
      </Routes>
    </Router>
  );
};

export default MyRoutes;
